// extracted by mini-css-extract-plugin
module.exports = {"description":"_3ExDhSumcrR4onFNIBM2L9"};